module.exports = __webpack_public_path__ + "static/media/6d_website_logo_Platinum_hkbn.0a7349af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6d_website_logo_Platinum_hkbn.jpg
// module id = 99
// module chunks = 0